import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class TextArea extends React.Component {
  handleChange(event) {
    var value = event.target.value;
    this.props.onChange(value);
  }

  render() {
    var {
      maxLength,
      value,
      description,
      hasError,
      placeholder,
      disabled,
      showCharCounter
    } = this.props;
    var className = classnames('text-field-large', 'textarea-input', this.props.className, {
      error: hasError
    });
    var descriptionComponent = null;
    if (description) {
      descriptionComponent = <div className="field-description">{description}</div>;
    }
    return (
      <div className="field">
        {descriptionComponent}
        <div className={className}>
          <textarea
            value={value}
            placeholder={placeholder}
            maxLength={maxLength}
            onChange={this.handleChange.bind(this)}
            disabled={disabled}
          />
          {showCharCounter && !!maxLength && (
            <div className={'char-counter'}>
              {(value && value.length) || 0} / {maxLength}
            </div>
          )}
        </div>
      </div>
    );
  }
}

TextArea.propTypes = {
  placeholder: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  showCharCounter: PropTypes.bool
};

TextArea.defaultProps = {
  placeholder: '',
  value: null,
  disabled: false,
  showCharCounter: false
};

TextArea.displayName = 'TextArea';

export default TextArea;
